import BUTTONGROUP, { BUTTON, buttongroupModel, buttongroupAttr } from '../../../../../DOM/GROUP/buttongroup/BUTTONGROUP.js';
import DIV from '../../../../../DOM/div/DIV.js';
import Hideable, { Hide, Show } from '../../../../../../interface/Hideable.js';
import { Activate, Deactivate } from '../../../../../../interface/Clickable.js';
import INPUT, { Disable, Disableable, Enable } from '../../../../../DOM/form/fieldset/field/input/INPUT.js';
import { HTTPINPUTTYPE } from '../../../../../../enums/HTTPINPUTTYPE.js';
import LABEL, { labelModel } from '../../../../../DOM/form/label/LABEL.js';
import Reset from '../../../../../../event/Reset.js';
import { fieldModel } from '../../../../../DOM/form/fieldset/field/FIELD.js';
import { makeStruct } from '../../../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../../enums/ModelData.js';
import { spanModel } from '../../../../../DOM/span/SPAN.js';
import FORMFIELDMESSAGE from '../../../../../DOM/form/fieldset/formfieldgroup/formfield/formfieldmessage/FORMFIELDMESSAGE.js';
import Switchable from '../../../../../../interface/Switchable.js';
// Model Structure
export const formFieldAttr = makeAttrStruct([
    ['type'],
    ['name'],
    ['value'],
    ['placeholder'],
    ['required'],
    ['disabled'],
    ['readonly'],
    ['autocomplete'],
    ['autofocus'],
    ['pattern']
]);
export const formFieldData = makeDataStruct([
    ['label', labelModel()],
    ['field', fieldModel()],
    ['message', spanModel()],
    ['buttons', buttongroupModel(buttongroupAttr('form-field-buttons'))]
]);
export const formFieldModel = makeStruct([
    ['attributes', formFieldAttr],
    ['data', formFieldData]
]);
// Simplified Model
// Class
export default class FORMFIELD extends DIV {
    label;
    message;
    field;
    buttonGroup;
    error;
    /** Constructs a Form Element */
    constructor(node, model) {
        super(node, model);
        this.error = null;
        this.addClass('form-field');
        this.implement(new Switchable(this));
        this.implement(new Disableable(this));
        this.on('enable', (event) => this.field.do(new Enable(this)))
            .on('disable', (event) => this.getField().do(new Disable(this)))
            .on('reset', (event) => this.getField().do(new Reset(this)))
            .on('activate', (event) => this.getField().do(new Activate()))
            .on('deactivate', (event) => this.getField().do(new Deactivate()));
        this.implement(new Hideable(this));
        if (model.attributes.type === HTTPINPUTTYPE.HIDDEN) {
            this.do(new Hide(this));
        }
        this.label = new LABEL(this, model.data.label).on('click', (event) => this.labelClick(event));
        this.message = new FORMFIELDMESSAGE(this, model.data.message).do(new Hide(this));
        this.field = this.createField(model.data.field);
        this.buttonGroup = new BUTTONGROUP(this, model.data.buttons);
        this.toggleDisabled = () => {
            console.log('FORMELEMENT.toggleDisabled()');
            if (this.el.hasAttribute('disabled')) {
                this.do(new Enable(node));
            }
            else {
                this.do(new Disable(node));
            }
            this.toggleClass('disabled');
            this.input.toggleDisabled();
        };
    }
    /** Validate the input value according to the attributes */
    validate() {
        return this.field.validate();
    }
    getField() {
        return this.field;
    }
    getLabel() {
        return this.label;
    }
    getMessage() {
        return this.message;
    }
    /** Return the value of this form field */
    getValue() {
        return this.field.getValue();
    }
    /** Return the button group of this form field */
    getButtonGroup() {
        return this.buttonGroup;
    }
    /** Focus the input element */
    labelClick(event) {
        this.field.do(new Enable(this.label));
    }
    /** Return the name of this input */
    getName() {
        return this.field.getAttribute('name');
    }
    /** Set the value of this input */
    setValue(value) {
        this.field.setValue(value);
    }
    setCustomValidity(message) {
        super.setCustomValidity(message);
        this.message.setInnerHTML(message);
    }
    getFormFieldGroup() {
        return this.getProtoTypeByClass('FORMFIELDGROUP');
    }
    getFieldset() {
        let formFieldGroup = this.getFormFieldGroup();
        if (formFieldGroup !== null) {
            return formFieldGroup.node;
        }
        return null;
    }
    getError() {
        return this.error;
    }
    setError(error) {
        this.error = error;
        return this;
    }
}
export { BUTTON, BUTTONGROUP, Disable, Disableable, DIV, Enable, Hide, INPUT, LABEL, Show };
